import {
    SYSTEMCONFIG_CHOOSE_CURRENT_SYSTEMCONFIGTYPE,
} from './constants';
  
export function chooseCurrentSystemConfigType(modal) {
    return {
      type: SYSTEMCONFIG_CHOOSE_CURRENT_SYSTEMCONFIGTYPE,
      data: modal,
    };
}
  
export function reducer(state, action) {
    switch (action.type) {
      case SYSTEMCONFIG_CHOOSE_CURRENT_SYSTEMCONFIGTYPE:
        return {
          ...state,
          currentSystemConfigType:action.data,
        };
  
      default:
        return state;
    }
}


// WEBPACK FOOTER //
// ./src/features/systemconfig/redux/chooseCurrentSystemConfigType.js